import React, { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import swal from 'sweetalert';
import ModalComponent from './ModalComponent';
import { getSaveUsers } from "../utilities/common"

export default function CreateEvent(props) {


    const [name, setName] = useState("")
    const [description, setDescription] = useState("")
    const [closeModal, setCloseModal] = useState(false)
    const [userData, setUserData] = useState()
    const [nameError, setNameError] = useState(false)
    const [englishError, setEnglishError] = useState(false)

    const [eventStatus, setEventStatus] = useState("LIVE")

    useEffect(() => {
        let user = getSaveUsers()
        setUserData(user)


    }, [])
    useEffect(() => {
        if (props.eventAction == 'edit') {
            setDescription(props.currentEditItem.event_description)
            setName(props.currentEditItem.event_name)
            setEventStatus(props?.currentEditItem?.status)

        } else {
            setDescription("")
            setName("")
            setEventStatus(eventStatus)
        }

    }, [props?.currentEditItem?.event_name])

    const createEvent = (e) => {
        const d = new Date();

        if (name) {

            var re = new RegExp("^([ a-zA-Z0-9 ]+)$");
            if (re.test(name)) {
                setEnglishError(false)

            } else {
                setEnglishError(true)
            }

            setNameError(false)
            let data = {
                id: uuidv4(),
                event_name: name,
                event_description: description,
                created_date: d,
                created_at: userData?.profileObj?.email,
                updated_at: "",
                status: eventStatus
            }
            console.log(data)
            // var myModal = document.getElementById('exampleModal')

            if (props.eventAction == 'add') {

                axios.post('https://n2o2jjkzp1.execute-api.ap-south-1.amazonaws.com/default/Mathrubhumi-LiveBlog', data)
                    .then((res) => {
                        
                        swal({
                            text: "Successfully  Created the Live event",
                            icon: "success",
                            timer: 2000,
                            buttons: false,
                        }).then(function () {
                            props.closeModal()
                            setDescription("")
                            setName("")
                            setEventStatus("LIVE")

                        })


                    })
                    .catch((err) => console.log(err))
            } else {
                data.id = props?.currentEditItem?.Id
                data.created_date = props?.currentEditItem?.created_date
                data.updated_at = userData?.profileObj?.email

                axios.put('https://n2o2jjkzp1.execute-api.ap-south-1.amazonaws.com/default/Mathrubhumi-LiveBlog', data)
                    .then((res) => {
                        console.log(res)
                        swal({
                            text: "Sucessfully Updated the Live event",
                            icon: "success",
                            timer: 2000,
                            buttons: false,
                        }).then(function () {
                            props.closeModal()
                            setEventStatus("LIVE")

                        })


                    })
                    .catch((err) => console.log(err))
            }
        }
        else {
            setNameError(true)
        }
    }

    const changeNameInput = (test) => {

        setNameError(false)
        let str = test;

        var pattern = new RegExp('^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$');

        console.log(test)

    }

    const textKeyPress = (event) => {


        var term = event.target.value
        var re = new RegExp("^([a-zA-Z0-9 ]+)$");

        if (re.test(term)) {

            setName(event.target.value)
            setEnglishError(false)

        } else {
            // event.preventDefault()
            if (event.target.value.length === 0) {
                setName(event.target.value)

            } else {

            }
            setEnglishError(true)

        }

    }

    const closeEventModal = () => {
        setNameError(false)
        setEnglishError(false)
        props.closeModal()
        setEventStatus("LIVE")
        setDescription("")
        setName("")
    }



    return (
        <div>
            {props.showModal ?
                <ModalComponent>
                    <div class="modal-dialog my-0">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">{props.eventAction === "add" ? "Create" : "Edit"} Event</h5>
                                <button type="button" class="btn-close" onClick={() => closeEventModal()}></button>
                            </div>
                            <div class="modal-body">
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1" class="form-label">Event Name <span className="l-required">*</span></label>
                                    <input value={name} type="text" class="form-control mb-2" id="exampleFormControlInput1" placeholder="Please enter event name" maxLength={65} required onChange={(e) => textKeyPress(e)} />
                                    {nameError ? <span style={{ color: "red" }}>*Required event name </span> : ""}
                                    {englishError ? <span style={{ color: "red" }}>  Use English text</span> : ""}
                                    <div className='p-2'>
                                        <p className='m-0' style={{ color: "gray", fontSize: "12px" }}> Maximum length : 65</p>
                                        {/* <p className='m-0' style={{ color: "gray", fontSize: "12px" }}>Must use only english</p> */}
                                    </div>
                                </div>
                                {props.eventAction === "add" ? "" :
                                    <div class="mb-3 d-flex align-items-center">
                                        <label for="exampleFormControlTextarea1" class="form-label m-0">Status</label>
                                        <div className='d-flex ms-3'>
                                            <button type="button" className={eventStatus === "LIVE" ? "l-btn-focus btn l-btn" : "btn l-btn"} onClick={() => setEventStatus("LIVE")}>Live</button>
                                            <button type="button" className={eventStatus === "CLOSE" ? "l-btn-focus btn l-btn" : "btn l-btn"} onClick={() => setEventStatus("CLOSE")}>Close</button>

                                        </div>
                                    </div>}
                                <div class="mb-3">
                                    <label for="exampleFormControlTextarea1" class="form-label">Description</label>
                                    <textarea value={description} class="form-control" id="exampleFormControlTextarea1" placeholder='Please enter description' rows="3" onChange={(e) => setDescription(e.target.value)}></textarea>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-primary" onClick={() => createEvent()}>Submit</button>
                            </div>
                        </div>
                    </div>
                </ModalComponent> : ""
            }
        </div >

    )
}
